
import Vue, { ComponentOptions, VNode, VueConstructor } from 'vue';
import Component from 'vue-class-component';
import { GraphRegistry, GraphSpec } from '@/graphregistry';
import { GraphView, NodeDescriptor } from '@/graph/graphview';
import { Generator } from '@/graph/generator';

export interface Segment {
    label: string
    index: number
}


@Component({
    props:  [ "specindex"],
    watch: {
        "searchclause": function(vnew, vold) {
            let me = this as Navigator
            me.onSearchTextChanged();
        }
    },
    template: `
    <div class="navigator column-container stretch" style="height: 100%; background-color: white; overflow: hidden;" >

        <div id="outer-container" class="row-container" style="overflow: hidden; background-color: white; flex: 1;">
            <div class="column-container" style="align-self: stretch; min-width: 1px; overflow: hidden; flex: 1;">
            <component :ref="'graphView'" v-bind:is="graphView" ></component>
            </div>
            <div class="column-container" style="flex: 0 0 200px;">

            <v-list subheader two-line style="overflow-y: auto;">
                <v-subheader>Graph-Navigation</v-subheader>
                <v-list-item-group >
                    <v-list-item  @click="onAllClick()">
                        <v-list-item-content class="small-list-item-content" >
                            <v-list-item-title class="small-list-item">Graph anzeigen</v-list-item-title>
                            <v-list-item-subtitle class="small-list-item">Übersicht anzeigen</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item v-for="(segment,index) in segments" :key="index" @click="onSegmentClick(segment)">
                        <v-list-item-content class="small-list-item-content" >
                            <v-list-item-title class="small-list-item">{{segment.label}}</v-list-item-title>
                            <v-list-item-subtitle class="small-list-item">{{segment.label}}</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list-item-group>
            </v-list>

            <div style="flex: 0 0 2rem;"></div>
            <v-subheader>Suche</v-subheader>

            <v-autocomplete v-model="searchclause" :items="searchItems"
                solo
                hide-no-data
                hide-selected
                item-text="captions"
                item-value="captions"
                placeholder="Textsuche"
                prepend-icon="mdi-database-search"
                return-object
            ></v-autocomplete>



            </div>
        </div>
    </div>
`,
})
export class Navigator extends Vue {

    graphView: VueConstructor = null
    svgraw = ""
    segments: Segment[] = []
    searchclause : NodeDescriptor = null
    searchItems : NodeDescriptor[] = []

    getGraphView(): GraphView {
        let s = this.$refs;
        return this.$refs.graphView as GraphView
    }

    async created() {
    }

    async mounted() {
        let specindex = Number.parseInt(this.$route.params.specindex as string)
        let spec = GraphRegistry.instance.getSpecs()[specindex]
        console.log("showing graph: " + spec.description)
        let gv = await this.fetchGv(spec)
        let svg = await Generator.instance.generateSvg(gv)
        this.graphView = GraphView
        this.$nextTick(() => {
            let g = this.getGraphView()
            g.inputSvg = svg
            g.rehashRawSvg(() => {
                g.showAll(true)
            })
            g.$on("update", () => {
                this.makeSegments()
                this.searchItems = this.getGraphView().computeNodeDescriptors()
            })
        })
    }

    async fetchGv(spec: GraphSpec) : Promise<string> {
        let response = await fetch(`/graphs/${spec.path}`, {
            method: 'get',
        })
        let blob = await response.blob()
        let gv = await blob.text()
        return gv;
    }

    makeSegments() {
        let gv = this.getGraphView()
        let indices = gv.computeClusterIndices()
        this.segments = []
        for (let index of indices) {
            this.segments.push({
                label: "Segment " + index,
                index: index 
            })
        }
    }

    onAllClick() {
        this.getGraphView().showAll()
    }

    onSegmentClick(segment: Segment) {
        this.getGraphView().showCluster(segment.index)
    }

    onSearchTextChanged() {
        console.log("searchtext changed: " + this.searchclause.captions)
        if (this.searchclause.id) {
            this.getGraphView().showNode(this.searchclause.id)
        } else {
            this.getGraphView().showAll()
        }
    }
}

